import { render } from "./EditRecensementPage.vue?vue&type=template&id=bc4fa6a4&ts=true"
import script from "./EditRecensementPage.vue?vue&type=script&lang=ts"
export * from "./EditRecensementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__